import React from 'react';
import PropTypes from 'prop-types';
import DocumentPreviewDialogBase from './DocumentPreviewDialogBase';

class DocumentPreviewDialog extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    onCancel: PropTypes.func,
    open: PropTypes.bool.isRequired,
    styleType: PropTypes.string,
  };
  static defaultProps = {
    styleType: 'default',
  };
  getStyles = type => {
    switch (type) {
      default:
        return {};
    }
  };
  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <DocumentPreviewDialogBase styles={styles} {...otherProps} />;
  }
}

export default DocumentPreviewDialog;
